import React from 'react'
import type { LucideIcon } from 'lucide-react'
import { motion } from 'framer-motion'

interface ActionButtonProps {
    icon: LucideIcon
    label: string
    onClick: () => void
    isActive?: boolean
    activeColor?: string
    activeBg?: string
    hoverColor?: string
}

export const ActionButton: React.FC<ActionButtonProps> = ({
    icon: Icon,
    label,
    onClick,
    isActive = false,
    activeColor = 'text-blue-600',
    activeBg = 'bg-blue-50',
    hoverColor = 'text-blue-600'
}) => {
    return (
        <div className="relative group/btn">
            <motion.button
                {...({
                    whileHover: { scale: 1.1 },
                    whileTap: { scale: 0.9 }
                } as any)}
                onClick={onClick}
                className={`p-1 hover:bg-gray-100 rounded transition-colors ${isActive
                    ? `${activeColor} ${activeBg}`
                    : `text-gray-500 hover:${hoverColor}`
                    }`}
            >
                <Icon className="w-3 h-3" />
            </motion.button>
            <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover/btn:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-10 shadow-sm">
                {label}
            </div>
        </div>
    )
}
